module.exports = __webpack_public_path__ + "media/images/athletes/1755-190a520a9dd587b05ae4a9a79516c51a.png";